import { Injectable } from '@angular/core';
import { PublicClientApplication, InteractionType, AuthenticationResult } from '@azure/msal-browser';
import { Router } from '@angular/router';
import { UserInfo } from 'app/user-info/user-info';
import { UserInfoService } from 'app/user-info/user-info.service';
import { jwtDecode } from "jwt-decode";
import { environment } from 'environments/environment';
import { environment as prodEnvironment } from '../environments/environment.prod';
import { environment as nonProdEnvironment } from '../environments/environment.nonprod';
@Injectable({
  providedIn: 'root'
})
export class MsalService {
  userInfo: UserInfo = new UserInfo();
  private msalInstance!: PublicClientApplication;
  isLoggedIn: boolean = false;
  first = true;

  accessToken = ''
  constructor(private router: Router, private userInfoService: UserInfoService) {
    this.initializeMsal();
  }

  async initializeMsal() {
    try {
      const clientId = this.getClientId();
      this.msalInstance = new PublicClientApplication({
        auth: {
          clientId: clientId,
          authority: 'https://login.microsoftonline.com/6197edc2-01c0-4b24-8919-8f827d5c4dfa',
          redirectUri: '/S1-Online-web'
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: true
        },
        system: {
          loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
              if (containsPii) {
                return;
              }
              switch (level) {
                case 0:
                  console.error(message);
                  break;
                case 1:
                  console.warn(message);
                  break;
                case 2:
                  console.info(message);
                  break;
                case 3:
                  console.log(message);
                  break;
              }
            }
          }
        }
      });
      await this.msalInstance.initialize();
      console.log('MSAL initialized successfully');
    } catch (error) {
      console.error('MSAL initialization failed', error);
    }
  }
  private getClientId(): string {

    
    const currentUrl = window.location.href;
    if (currentUrl.includes('s1online.amtrak')) {

      return prodEnvironment.clientId;
    }
    else{
      return nonProdEnvironment.clientId;
    } 
  }
  async login() {
    if (!this.msalInstance) {
      console.error('MSAL instance is not initialized.');
      return;
    }
    localStorage.removeItem('idToken')
    try {
      await this.msalInstance.handleRedirectPromise();
      const response: AuthenticationResult = await this.msalInstance.loginPopup({
          scopes: ['openid'],
        redirectUri: "/S1-Online-web"
      });
      if (response && response.account) {
        this.setLoginCookie(response.idToken,response.account.username);
       this.router.navigate(['/S100']);    
                 this.accessToken = response.idToken;
                // localStorage.setItem('msalAccount', JSON.stringify(response.account));
        }
      // Handle the redirectPromise here
      // const response: AuthenticationResult = await this.msalInstance.handleRedirectPromise();
      // if (response && response.account) {
      //   this.msalInstance.setActiveAccount(response.account)
      //   localStorage.setItem('msalAccount', JSON.stringify(response.account));
      // }
    } catch (error) {
      console.error('Login failed', error);
    }
  }



  async setLoginCookie(cookieValue: string, account: string) {

    try {
      // Decode the JWT token from the cookie value
      const decodedToken = jwtDecode(cookieValue);
    
      // Define the required key to extract
      const requiredKey: string = 'EmployeeID'; 
    
      // Initialize variables for extracted value and user ID
      let extractedValue: string | null = null;
      let userId: string | null = null;
    
      // Check if the decoded token has the required key
      if (decodedToken.hasOwnProperty(requiredKey)) {
        // Extract the value of the key from the decoded token
        const valueOfKey: any = decodedToken[requiredKey];
        
        // Store the extracted value in a variable
        extractedValue = valueOfKey;

    
        // Extract a substring for the user ID, ensuring it's not null
        if (extractedValue) {
          userId = extractedValue.slice(0, 7);
        } else {
          console.error('Extracted value is null or undefined.');
        }
      } else {
        console.error(`Key "${requiredKey}" not found in JWT.`);
      }
    
      // Update userInfo object with the user ID
      if (userId) {
               this.userInfo.termId = this.generateRandomAlphaNumericCode();

        this.userInfo.userId=userId;
      } else {
        console.error('User ID is null or undefined. Cannot set userInfo.termId.');
      }
    
      // Store the user info and update cookies
      //await this.userInfoService.setUserInfo2(this.userInfo, cookieValue);
      
      const expirationDate = new Date();
      expirationDate.setHours(expirationDate.getHours() + 1); // Set cookie to expire in 1 hour
    
      document.cookie = `S1sessionData=${cookieValue}; expires=${expirationDate.toUTCString()}; path=/`;
         document.cookie = `S1termId=${this.userInfo.termId}; expires=${expirationDate.toUTCString()}; path=/`;

      if (extractedValue) {
        document.cookie = `S1account1=${extractedValue}; expires=${expirationDate.toUTCString()}; path=/`;
      } else {
        console.error('Extracted value is null or undefined. Cannot set User Info cookie.');
      }
    
    } catch (error) {
      // Handle any unexpected errors
      console.error('An error occurred:', error);
    }
    
  }

generateRandomAlphaNumericCode(): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }
  getCookieValue(key: string) {
    var name=key;
    if(key==null){
       name = 'S1sessionData';
    }
    else{
       name=key;
    }
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }


  async logout() {
    try {
      // Clear MSAL cache
      this.msalInstance.logoutRedirect({
        account : this.msalInstance.getActiveAccount(),
        postLogoutRedirectUri: '/', // Specify your desired post-logout redirect URI
      }).catch((error) => {
        console.error('Error during logout:', error);
      });
      sessionStorage.removeItem('idToken')
      // Clear browser storage (if needed)
      localStorage.clear(); // or sessionStorage.clear();
      // Clear cookies (if needed)
      document.cookie.split(";").forEach((c) => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });      
      // Set the isLoggedIn flag to false
      this.isLoggedIn = false;
  
      console.log('Logout successful');
    } catch (error) {
      console.error('Logout failed', error);
    }
  }

 async setUser(){
    const accountToken = this.getCookieValue('S1sessionData')//localStorage.getItem('idToken')
    const userId = this.getCookieValue('S1account1')
    const termId = this.getCookieValue('S1termId')
    this.userInfo.userId=userId;
    // const termId1: string = termId.slice(4,7); 
     this.userInfo.termId = termId;
  await  this.userInfoService.setUserInfo2(this.userInfo,accountToken);

  }

  async checkIfLoggedIn() {
    try {
      // Check if there's a logged-in user in cache
      const accountToken = this.getCookieValue('S1sessionData')//localStorage.getItem('idToken')
      const userId = this.getCookieValue('S1account1')
      const termId = this.getCookieValue('S1termId')
    

      if (accountToken) {
        // User is logged in
      this.userInfo.userId=userId;
      //   const termId1: string = termId.slice(4,7); 
         this.userInfo.termId = termId;
// this.userInfo.userId = userId1;
  // await this.userInfoService.setUserInfo2(this.userInfo,accountToken);

        this.isLoggedIn = true;
        return true
      } else {
        // No user is logged in
        console.log('No user is logged in.');
        this.isLoggedIn = false;
        return false
      }
    } catch (error) {
      console.error('Error checking login status:', error);
      return false;
    }
  }

   async getProtectedData() {
    const expirationDate = new Date();
        expirationDate.setHours(expirationDate.getHours() + 1);
    this.msalInstance.acquireTokenSilent({
      scopes: ['openid'] // Specify the scopes for your API
    }).then((response: AuthenticationResult) => {
      // this.setLoginCookie(response.idToken)

    }).catch((error) => {
      console.error('Error while acquiring access token:', error);
    });

   
  }


}
